import { render, staticRenderFns } from "./SelimTest.vue?vue&type=template&id=16b73d98&scoped=true&"
import script from "./SelimTest.vue?vue&type=script&lang=js&"
export * from "./SelimTest.vue?vue&type=script&lang=js&"
import style0 from "./SelimTest.vue?vue&type=style&index=0&id=16b73d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b73d98",
  null
  
)

export default component.exports